module.exports = __webpack_public_path__ + "img/done.83888857.svg";